import type { Training } from "api/training/Training.typed";

export function formatTrainingSessionOrdinal(nextSessionIndex: number): string {
  if (nextSessionIndex < 1) return "0";
  if (nextSessionIndex === 1) return "1ère";
  return `${nextSessionIndex}ème`;
}

export function formatInProgressTrainingsSessionsTooltip(
  trainings: Training[] | undefined | null,
): string | null {
  if (!trainings?.length) return null;
  const rows = trainings
    .filter((t) => (t.Status ?? "").trim() === "En cours")
    .map((t) => {
      const label = (t.Qualification?.trim() || `Formation #${t.TrainingTemplateID ?? "?"}`).trim();
      const completed = t.Sessions ?? 0;
      const nextOrd = formatTrainingSessionOrdinal(completed + 1);
      return `${label} : ${nextOrd} séance`;
    });
  if (rows.length === 0) return null;
  return rows.join("\n");
}
